import { initClearRefinementsWidget} from "./algolia-clear-refinements-component.js";
import { initCourseStatusesRefinementList } from "./algolia-course-statuses-rl-component";
import { initEnrollmentStatusRefinementList } from "./algolia-enrollment-status-rl-component";
import { initHitsPerPageWidget } from "./algolia-hits-per-page-component";
import { initHitsWidget } from "./algolia-hits-component";
import { initInfiniteHitsWidget } from "./algolia-infinite-hits-component";
import { initMenuWidget } from "./algolia-menu-component.js";
import { initMenuSelectWidget } from "./algolia-menu-select-component";
import { initPaginationWidget } from "./algolia-pagination-component";
import { initRefinementListWidget } from "./algolia-refinement-list-component";
import { initSearchBoxWidget } from "./algolia-search-box-component";
import { initSortByWidget } from "./algolia-sortby-component";
import { initStatsWidget } from "./algolia-stats-component";

function initFilterAccordions() {
  document.querySelectorAll('.tgbl-filter-accordion__button').forEach(btn => {
    btn.addEventListener('click', () => {
      const accordion = btn.closest('.tgbl-filter-accordion');
      if (!accordion) return;
      const isOpen = accordion.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  });
}

document.addEventListener("DOMContentLoaded", function() {
  initFilterAccordions();
  initClearRefinementsWidget();
  initCourseStatusesRefinementList();
  initEnrollmentStatusRefinementList();
  initHitsPerPageWidget();
  initHitsWidget();
  initInfiniteHitsWidget();
  initMenuWidget();
  initMenuSelectWidget();
  initPaginationWidget();
  initRefinementListWidget();
  initSearchBoxWidget();
  initSortByWidget();
  initStatsWidget();
})